import { render, staticRenderFns } from "./PreAlignment.vue?vue&type=template&id=bc969a2a"
import script from "./PreAlignment.vue?vue&type=script&lang=js"
export * from "./PreAlignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports